import Connected from './Connected';
import Detail from './Detail';

Connected.Detail = Detail;

export default Connected;
